// extracted by mini-css-extract-plugin
export default {"wrapperGallery":"F6XRA","photoWrapper":"HswdQ","photo":"jSSyI","cnPhoto":"n0bvG","lastPhoto":"hQhEk","background":"Mz5bk","countRest":"Ezxrz"};